import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconTokens, InputTypeToken, SizeTypeTokens, StackHeight, StackJustifyContent, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from './types';
import { onChangeTab, onCtaCopyLink, onCtaShareLink, onCtaTelegram, onCtaWhatsApp, onFaq, onKnowMore, onLoadReferredPartner, onSearchReferredPartner, onSortReferredPartner, } from './actions';
import { SideBarBuilderDS } from '../sideNavBar';
import sharedPropsService from '../../SharedPropsService';
import SharedPropsService from '../../SharedPropsService';
import { partnerApi, StoreKey } from '../../configs/api';
import { getAppHeader, initializeFirebase } from '../../configs/config';
import { getReferredPartnerCardDataFromFireBase, getRewardStructureCardDataFromFireBase, navigateByUrl, ReferredPartnerMobileCardBuilder, ReferredPartnerTableBuilder, ShowNewRmContactButton } from '../partnerWeb_Dashboard/utils';
import { ReferredPartnerEmptyStatePageBuilder } from '../emptyState/indexReferredPartner';
import { addMinutesToCurrentTimeStamp, appendURlWithParam, isMobile, setAppHeader } from '../../configs/utils';
import { PARTNER_CACHE_EXPIRE_TIME } from '../../configs/constants';
import { PartnerHeader } from "../partnerWeb_Dashboard/partnerHeader";
import { GoToFaq, GoToHome, GoToPhone, GoToWhatsapp } from "../partnerSignUp/actions";
import { handleConnection, onLogoutPress, openMenu } from "../partnerWeb_Dashboard/actions";
import { BottomNavBuilderDS } from "../bottomNav";
export const template = async (referredPartnerData, advisorLink, partnerName, showNewRmContactButton, rmData, rewardStructureData, rewardStructureImageUrl, referredPartnerCardData, partnerInterestRate) => ({
    layout: {
        id: ROUTE.PARTNER_REFERRED_PARTNER,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            {
                id: 'partnerHeader',
                type: WIDGET.STACK,
                position: POSITION.ABSOLUTE_TOP,
            },
            showNewRmContactButton ? { id: 'rmContactButton', type: WIDGET.RM_CONTACT_LIST, position: POSITION.ABSOLUTE_BOTTOM } : {},
            !isMobile()
                ? {
                    id: 'sideNav',
                    type: WIDGET.STACK,
                    position: POSITION.NAVBAR_LEFT,
                }
                : {},
            !isMobile()
                ? { id: 'referredPartnerRGStack', type: WIDGET.STACK }
                : { id: 'referredPartnerMobStack', type: WIDGET.STACK },
            isMobile() ? { id: 'BottomNavContainer', type: WIDGET.STACK, position: POSITION.ABSOLUTE_BOTTOM } : {}
        ],
    },
    datastore: {
        rmContactButton: {
            title: 'Contact us',
            rmData,
            handleRmConnection: {
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                type: ACTION.HANDLE_CONNECTION,
                payload: {}
            }
        },
        ...(await PartnerHeader(ROUTE.PARTNER_REFERRED_PARTNER)),
        ...(await SideBarBuilderDS(ROUTE.PARTNER_REFERRED_PARTNER)),
        ...await BottomNavBuilderDS(ROUTE.PARTNER_REFERRED_PARTNER),
        referredPartnerMobStack: {
            height: StackHeight.MATCH_PARENT,
            type: StackType.column,
            padding: {
                all: SizeTypeTokens.XL
            },
            widgetItems: [
                referredPartnerCardData?.length > 0
                    ? { id: 'partnerPromotionCard1', type: WIDGET.PARTNER_PROMOTION_CARD }
                    : { id: 'PromotionCard', type: WIDGET.PROMOTION_CARD },
                { id: 'referredPartnerMobSpace0', type: WIDGET.SPACE },
                {
                    id: 'referMfdAndAdvisorsStackMob',
                    type: WIDGET.STACK,
                },
                { id: 'referredPartnerMobSpace3', type: WIDGET.SPACE },
                {
                    id: 'rewardStructureMobT1',
                    type: WIDGET.TEXT,
                },
                { id: 'referredPartnerMobSpace4', type: WIDGET.SPACE },
                {
                    id: 'rewardStructureImageWeb1',
                    type: WIDGET.REWARD_STRUCTURE_WINTER,
                },
                { id: 'referredPartnerMobSpace6', type: WIDGET.SPACE },
                {
                    id: 'referredPartnerMobTandCBtn',
                    type: WIDGET.BUTTON,
                },
                { id: 'referredPartnerMobSpace5', type: WIDGET.SPACE },
                { id: 'referredPartnerMobSpaceT1', type: WIDGET.TEXT },
                { id: 'referredPartnerMobSpace7', type: WIDGET.SPACE },
                referredPartnerData?.length > 0 ? { id: 'referredPartnerMobSearchInput', type: WIDGET.INPUT } : {},
                referredPartnerData?.length > 0 ? { id: 'referredPartnerMobSpace8', type: WIDGET.SPACE } : {},
                referredPartnerData?.length > 0 ? { id: 'referredPartnerCardStack', type: WIDGET.STACK } : {
                    id: 'emptyStateStack_ReferredPartner',
                    type: WIDGET.STACK,
                },
            ],
        },
        partnerPromotionCard1: {
            data: referredPartnerCardData
        },
        rewardStructureImageWeb1: {
            isMobile: isMobile(),
            dataList: rewardStructureData,
            imageUrl: rewardStructureImageUrl
        },
        referredPartnerMobSearchInput: {
            title: 'Search by name',
            value: '',
            placeholder: 'Search by name',
            type: InputTypeToken.DEFAULT,
            isFocus: false,
            action: {
                type: ACTION.ON_SEARCH_RP,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    value: '',
                    widgetId: 'referredPartnerMobSearchInput',
                },
            },
        },
        referredPartnerMobSpaceT1: {
            label: 'Referred Partners',
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            fontFamily: FontFamilyTokens.Poppins,
            lineHeight: 26,
        },
        referredPartnerMobSpace8: {
            size: SizeTypeTokens.XL
        },
        referredPartnerMobSpace7: {
            size: SizeTypeTokens.XL
        },
        referredPartnerCardStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                ...ReferredPartnerMobileCardBuilder(referredPartnerData).WIDGET_STORE
            ]
        },
        ...ReferredPartnerMobileCardBuilder(referredPartnerData).DATA_STORE,
        referredPartnerMobTandCBtn: {
            label: 'View all T&C',
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.MediumSoftFilled,
            action: {
                type: ACTION.FAQ,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {},
            },
        },
        rewardStructureMobT1: {
            label: `Reward structure`,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
            color: ColorTokens.Grey_Night,
        },
        referMfdAndAdvisorsStackMob: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            padding: {
                top: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'referMfdAndAdvisorsStackT1Mob', type: WIDGET.TEXT },
                { id: 'referMfdAndAdvisorsStackT2', type: WIDGET.TEXT },
                { id: 'referredPartnerMobSpace2', type: WIDGET.SPACE },
                { id: 'referMfdAndAdvisorsTelegramMob', type: WIDGET.BUTTON },
                { id: 'referMfdAndAdvisorsMobBottomStack', type: WIDGET.STACK },
            ],
        },
        referMfdAndAdvisorsTelegramMob: {
            label: 'Whatsapp',
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.MediumFilled,
            icon: {
                name: IconTokens.Whatsapp,
            },
            action: {
                type: ACTION.CTA_WHATSAPP,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    advisorLink: advisorLink,
                    partnerName: partnerName,
                    partnerInterestRate: partnerInterestRate
                },
            },
        },
        referMfdAndAdvisorsMobBottomStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.row,
            padding: {
                top: SizeTypeTokens.XL,
            },
            widgetItems: [
                {
                    id: 'referMfdAndAdvisorsMobBottomStack1',
                    type: WIDGET.STACK,
                },
                {
                    id: 'referredPartnerMobSpace1',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'referMfdAndAdvisorsMobBottomStack2',
                    type: WIDGET.STACK,
                },
            ],
        },
        referMfdAndAdvisorsMobBottomStack1: {
            flex: 1,
            widgetItems: [
                {
                    id: 'referMfdAndAdvisorsMobBottomStackButton1',
                    type: WIDGET.BUTTON,
                },
            ],
        },
        referMfdAndAdvisorsMobBottomStack2: {
            flex: 1,
            widgetItems: [
                {
                    id: 'referMfdAndAdvisorsMobBottomStackButton2',
                    type: WIDGET.BUTTON,
                },
            ],
        },
        referMfdAndAdvisorsMobBottomStackButton1: {
            label: 'Telegram',
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.MediumSoftFilled,
            icon: {
                name: IconTokens.Telegram,
            },
            action: {
                type: ACTION.CTA_TELEGRAM,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    advisorLink: advisorLink,
                    partnerName: partnerName,
                },
            },
        },
        referMfdAndAdvisorsMobBottomStackButton2: {
            label: 'Share Link',
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.MediumSoftFilled,
            icon: {
                name: IconTokens.Share,
            },
            action: {
                type: ACTION.CTA_SHARE_LINK,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    advisorLink: advisorLink,
                    partnerName: partnerName,
                },
            },
        },
        referredPartnerRGStack: {
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            type: StackType.column,
            maxWidth: 800,
            padding: {
                top: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXL,
                left: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
                right: isMobile() ? SizeTypeTokens.XL : SizeTypeTokens.XXXXL,
            },
            widgetItems: [
                {
                    id: 'referredPartnerTopStack1',
                    type: WIDGET.STACK,
                },
                { id: 'referredPartnerspace3', type: WIDGET.SPACE },
                {
                    id: 'referMfdAndAdvisorsStack',
                    type: WIDGET.STACK,
                },
                {
                    id: 'referredPartnerspace7',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'referredPartnerDivider1',
                    type: WIDGET.DIVIDER,
                },
                {
                    id: 'referredPartnerspace8',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'rewardStructureT1',
                    type: WIDGET.TEXT,
                },
                {
                    id: 'referredPartnerspace12',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'referredPartnerRGStack1',
                    type: WIDGET.REWARD_STRUCTURE_WINTER,
                },
                {
                    id: 'referredPartnerspace9',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'rewardStructureButtonStack',
                    type: WIDGET.STACK,
                },
                { id: 'referredPartnerspace11', type: WIDGET.SPACE },
                { id: 'referredPartnerCountText', type: WIDGET.TEXT },
                { id: 'referredPartnerspace0', type: WIDGET.SPACE },
                referredPartnerData?.length > 0
                    ? { id: 'referredPartnertopStack', type: WIDGET.STACK }
                    : {
                        id: 'emptyStateStack_ReferredPartner',
                        type: WIDGET.STACK,
                    },
                { id: 'referredPartnerspace2', type: WIDGET.SPACE },
                referredPartnerData?.length > 0
                    ? {
                        id: 'referredPartnerTableMainStack',
                        type: WIDGET.STACK,
                    }
                    : {},
            ],
        },
        referredPartnerRGStack1: {
            isMobile: isMobile(),
            dataList: rewardStructureData,
            imageUrl: rewardStructureImageUrl
        },
        rewardStructureImageStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                {
                    id: 'rewardStructureImageWeb',
                    type: WIDGET.REWARD_STRUCTURE,
                },
            ],
        },
        // rewardStructureImageWeb: <ImageProps>{
        //     uri: 'https://volt-images.s3.ap-south-1.amazonaws.com/rewardStructureNew1.png',
        //     size: ImageSizeTokens.FULL,
        //     width: 700,
        //     height: 140,
        //     resizeMode: ResizeModeToken.CONTAIN,
        // },
        rewardStructureImageWeb: {
            title: 'https://volt-images.s3.ap-south-1.amazonaws.com/rewardStructureNew1.png',
        },
        rewardStructureButtonStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.center,
            widgetItems: [
                // { id: 'rewardStructureButtonFaqButton', type: WIDGET.BUTTON },
                // { id: 'referredPartnerspace10', type: WIDGET.SPACE },
                {
                    id: 'rewardStructureButtonViewAllTandC',
                    type: WIDGET.BUTTON,
                },
            ],
        },
        // rewardStructureButtonFaqButton: <ButtonProps & WidgetProps>{
        //     label: '      Faq      ',
        //     width: ButtonWidthTypeToken.CONTENT,
        //     type: ButtonTypeTokens.MediumSoftFilled,
        //     // action: {
        //     //     type: ACTION.ON_REGISTER_LEADS,
        //     //     routeId: ROUTE.PARTNER_LEAD,
        //     //     payload: {}
        //     // }
        // },
        rewardStructureButtonViewAllTandC: {
            label: 'View all T&C',
            width: ButtonWidthTypeToken.CONTENT,
            type: ButtonTypeTokens.MediumSoftFilled,
            action: {
                type: ACTION.FAQ,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {},
            },
        },
        referredPartnerDivider1: {
            color: ColorTokens.Grey_Chalk,
            size: DividerSizeTokens.SM,
        },
        referMfdAndAdvisorsStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'referMfdAndAdvisorsStackT1', type: WIDGET.TEXT },
                { id: 'referMfdAndAdvisorsStackT2', type: WIDGET.TEXT },
                {
                    id: 'referredPartnerspace6',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'referMfdAndAdvisorsStackC1',
                    type: WIDGET.STACK,
                },
            ],
        },
        rewardStructureT1: {
            label: `Rewards structure`,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.XXL,
            fontWeight: '600',
            lineHeight: 26,
            color: ColorTokens.Grey_Night,
        },
        referMfdAndAdvisorsStackT1: {
            label: `Refer MFDs or advisors `,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.XXL,
            fontWeight: '600',
            lineHeight: 26,
            color: ColorTokens.Grey_Night,
        },
        referMfdAndAdvisorsStackT1Mob: {
            label: `Refer MFDs or advisors `,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.LG,
            fontWeight: '600',
            lineHeight: 26,
            color: ColorTokens.Grey_Night,
        },
        referMfdAndAdvisorsStackT2: {
            label: `Let's stop redemptions together! Refer MFDs/IFAs and share the benefits.`,
            fontFamily: FontFamilyTokens.Inter,
            fontSize: FontSizeTokens.MD,
            fontWeight: '400',
            lineHeight: 26,
            color: ColorTokens.Grey_Charcoal,
        },
        referMfdAndAdvisorsStackC1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                {
                    id: 'referMfdAndAdvisorsStackB1',
                    type: WIDGET.STACK,
                },
                {
                    id: 'referredPartnerspace4',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'referMfdAndAdvisorsStackB2',
                    type: WIDGET.STACK,
                },
                {
                    id: 'referredPartnerspace5',
                    type: WIDGET.SPACE,
                },
                {
                    id: 'referMfdAndAdvisorsStackB3',
                    type: WIDGET.STACK,
                },
            ],
        },
        referMfdAndAdvisorsStackB1: {
            flex: 1,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [{ id: 'referMfdAndAdvisorsB1', type: WIDGET.BUTTON }],
        },
        referMfdAndAdvisorsStackB2: {
            flex: 1,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [{ id: 'referMfdAndAdvisorsB2', type: WIDGET.BUTTON }],
        },
        referMfdAndAdvisorsStackB3: {
            flex: 1,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [{ id: 'referMfdAndAdvisorsB3', type: WIDGET.BUTTON }],
        },
        referMfdAndAdvisorsB1: {
            label: 'Whatsapp',
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.MediumFilled,
            icon: {
                name: IconTokens.Whatsapp,
            },
            action: {
                type: ACTION.CTA_WHATSAPP,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    value: 'WEB',
                    advisorLink: advisorLink,
                    partnerName: partnerName,
                    partnerInterestRate: partnerInterestRate
                },
            },
        },
        referMfdAndAdvisorsB2: {
            label: 'Telegram',
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.MediumSoftFilled,
            icon: {
                name: IconTokens.Telegram,
            },
            action: {
                type: ACTION.CTA_TELEGRAM,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    advisorLink: advisorLink,
                    partnerName: partnerName,
                },
            },
        },
        referMfdAndAdvisorsB3: {
            label: 'Copy link',
            width: ButtonWidthTypeToken.FULL,
            type: ButtonTypeTokens.MediumSoftFilled,
            icon: {
                name: IconTokens.Copy,
            },
            action: {
                type: ACTION.CTA_COPY_LINK,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    advisorLink: advisorLink,
                    partnerName: partnerName,
                },
            },
        },
        referredPartnerTopStack1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                referredPartnerCardData?.length > 0
                    ? { id: 'partnerPromotionCard1', type: WIDGET.PARTNER_PROMOTION_CARD }
                    : { id: 'PromotionCard', type: WIDGET.PROMOTION_CARD },
            ],
        },
        PromotionCard: {
            title: 'something',
            action: {
                type: ACTION.KNOW_MORE,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {},
            },
            isCta: isMobile() ? false : true,
        },
        ...ReferredPartnerEmptyStatePageBuilder(),
        referredPartnerCountText: {
            // label: `${
            //     referredPartnerData?.length ? referredPartnerData?.length : 0
            // } Referred partners`,
            label: `Referred partners`,
            fontFamily: FontFamilyTokens.Poppins,
            fontSize: FontSizeTokens.XXL,
            fontWeight: '600',
            lineHeight: 26,
        },
        referredPartnerTableMainStack: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.CONTENT,
            widgetItems: [
                { id: 'referredPartnerTableStack', type: WIDGET.STACK },
                { id: 'space32', type: WIDGET.SPACE },
            ],
        },
        referredPartnerTableStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.CONTENT,
            widgetItems: [
                { id: 'referredPartnerTableStack1', type: WIDGET.STACK },
            ],
        },
        referredPartnerTableStack1: {
            flex: 1,
            widgetItems: [{ id: 'referredPartnerTable', type: WIDGET.TABLE }],
        },
        space32: {
            size: SizeTypeTokens.Size32
        },
        referredPartnerTable: {
            numOfCol: referredPartnerData ? referredPartnerData?.length : 0,
            width: StackWidth.MATCH_PARENT,
            height: StackHeight.MATCH_PARENT,
            titleMap: {
                ...ReferredPartnerTableBuilder(referredPartnerData).Title_MAP,
            },
            titleConfig: {
                ...ReferredPartnerTableBuilder(referredPartnerData)
                    .TITLE_CONFIG,
            },
            widgetData: {
                ...ReferredPartnerTableBuilder(referredPartnerData).DATA,
            },
            data: referredPartnerData,
            sortAction: {
                type: ACTION.ON_SORT_RP,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    value: '',
                },
            },
            // selected: true,
            // allSelectedAction: {
            //     type: ACTION.ON_SELECT_ALL_LEADS,
            //     routeId: ROUTE.PARTNER_DASHBOARD,
            //     payload: {
            //
            //     }
            // }
        },
        ...ReferredPartnerTableBuilder(referredPartnerData).DATA_STORE,
        referredPartnertopStack: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'referredPartnerSearchStackLeft', type: WIDGET.STACK },
                { id: 'referredPartnerSearchStackRight', type: WIDGET.STACK },
            ],
        },
        referredPartnerSearchStackLeft: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 1,
            widgetItems: [
                { id: 'referredPartnerSeachInput', type: WIDGET.INPUT },
            ],
        },
        referredPartnerSearchStackRight: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            flex: 2,
            widgetItems: [],
        },
        referredPartnerSeachInput: {
            title: 'Search by name',
            value: '',
            placeholder: 'Search by name',
            type: InputTypeToken.DEFAULT,
            action: {
                type: ACTION.ON_SEARCH_RP,
                routeId: ROUTE.PARTNER_REFERRED_PARTNER,
                payload: {
                    value: '',
                    widgetId: 'referredPartnerSeachInput',
                },
            },
        },
        referredPartnerspace0: { size: SizeTypeTokens.XXXL },
        referredPartnerspace1: { size: SizeTypeTokens.LG },
        referredPartnerspace2: { size: SizeTypeTokens.LG },
        referredPartnerspace3: { size: SizeTypeTokens.Size32 },
        referredPartnerspace4: { size: SizeTypeTokens.XL },
        referredPartnerspace5: { size: SizeTypeTokens.XL },
        referredPartnerspace6: { size: SizeTypeTokens.XL },
        referredPartnerspace7: { size: SizeTypeTokens.Size32 },
        referredPartnerspace8: { size: SizeTypeTokens.Size32 },
        referredPartnerspace9: { size: SizeTypeTokens.XL },
        referredPartnerspace10: { size: SizeTypeTokens.XL },
        referredPartnerspace11: { size: SizeTypeTokens.Size32 },
        referredPartnerspace12: { size: SizeTypeTokens.XXXL },
        referredPartnerMobSpace0: { size: SizeTypeTokens.XL },
        referredPartnerMobSpace1: { size: SizeTypeTokens.XL },
        referredPartnerMobSpace2: { size: SizeTypeTokens.XL },
        referredPartnerMobSpace3: { size: SizeTypeTokens.XXXL },
        referredPartnerMobSpace4: { size: SizeTypeTokens.XL },
        referredPartnerMobSpace5: { size: SizeTypeTokens.XL },
        referredPartnerMobSpace6: { size: SizeTypeTokens.XL },
    },
});
export const PartnerReferredPartnerMF = {
    onLoad: async ({ openNewTab, asyncStorage, network, instrumentTrack, ...props }, { setIsUserLoggedIn: boolean }) => {
        appendURlWithParam('referredpartner');
        await setAppHeader();
        await initializeFirebase();
        const { rewardStructureData, rewardStructureImageUrl } = await getRewardStructureCardDataFromFireBase();
        const referredPartnerCardData = await getReferredPartnerCardDataFromFireBase();
        const user = JSON.parse(await asyncStorage.get(StoreKey.userContext));
        const token = await asyncStorage.get(StoreKey.accessToken);
        const dashboardActiveId = localStorage.getItem('DASHBOARD_ACTIVE_ID');
        await SharedPropsService.setToken(token);
        await sharedPropsService.setUser(user);
        const partnerAccountId = user?.linkedPartnerAccounts[0].accountId;
        await sharedPropsService.setPartnerSideBarActiveId(dashboardActiveId);
        // ------ //
        const accessToken = await asyncStorage.get(StoreKey.accessToken);
        if (!accessToken) {
            await navigateByUrl(ROUTE.PARTNER_SIGNUP, openNewTab, true);
            return;
        }
        const currentTimeStamp = Date.now().valueOf();
        const cacheExpireTime = await sharedPropsService.getPartnerCacheExpireTime();
        let referredPartnerData = [];
        const partnerReferredPartnerDataSharedPropsService = await sharedPropsService.getReferredPartnerData();
        const header = await getAppHeader();
        // header["X-AppPlatform"] = 'VOLT_WEB_APP';
        const responseAdvisorLink = await network.get(`${partnerApi.advisorLink}${partnerAccountId}`, {
            headers: header
        }, async () => { }, {
            isPartnerPlatform: true
        });
        const advisorLink = responseAdvisorLink?.data?.link;
        const partnerName = user?.linkedPartnerAccounts[0].partnerName;
        if (currentTimeStamp > cacheExpireTime.ReferredPartnerCacheExpireTime ||
            partnerReferredPartnerDataSharedPropsService.length === 0) {
            const partnerResponse = await network.get(`${partnerApi.clientList}${partnerAccountId}/partners/all`, {
                headers: await getAppHeader(),
            }, async () => { }, {
                isPartnerPlatform: true,
            });
            if (partnerResponse.status === 200) {
                referredPartnerData = partnerResponse.data;
                console.log('referredPartnerData: ', referredPartnerData);
                await sharedPropsService.setReferredPartnerData(referredPartnerData);
                await sharedPropsService.setPartnerCacheExpireTime({
                    ...cacheExpireTime,
                    ReferredPartnerCacheExpireTime: addMinutesToCurrentTimeStamp(PARTNER_CACHE_EXPIRE_TIME),
                });
            }
            // else {
            //     await clearAllData();
            //     await partnerNavigate(ROUTE.PARTNER_SIGNUP);
            // }
        }
        else {
            referredPartnerData =
                await sharedPropsService.getReferredPartnerData();
        }
        await SharedPropsService.getPartnerSideBarActiveId();
        instrumentTrack("INVITE_PARTNER_PAGE_VIEWED");
        let showNewRmContactButton = false;
        showNewRmContactButton = await ShowNewRmContactButton();
        const rmContactResponse = await network.get(`${partnerApi.getMappedRMDetails}${partnerAccountId}`, {
            headers: header
        });
        const rmData = rmContactResponse?.data;
        const partnerInterestRate = await SharedPropsService.getFirebaseConfig()?.partner_interest_rate;
        return Promise.resolve(template(referredPartnerData, advisorLink, partnerName, showNewRmContactButton, rmData, rewardStructureData, rewardStructureImageUrl, referredPartnerCardData, partnerInterestRate));
    },
    actions: {
        [ACTION.ON_SEARCH_RP]: onSearchReferredPartner,
        [ACTION.ON_SORT_RP]: onSortReferredPartner,
        [ACTION.ON_LOAD]: onLoadReferredPartner,
        [ACTION.CHANGE_TAB]: onChangeTab,
        [ACTION.CTA_WHATSAPP]: onCtaWhatsApp,
        [ACTION.CTA_TELEGRAM]: onCtaTelegram,
        [ACTION.CTA_COPY_LINK]: onCtaCopyLink,
        [ACTION.CTA_SHARE_LINK]: onCtaShareLink,
        [ACTION.KNOW_MORE]: onKnowMore,
        [ACTION.FAQ]: onFaq,
        [ACTION.GO_TO_HOME]: GoToHome,
        [ACTION.GO_TO_FAQ]: GoToFaq,
        [ACTION.GO_TO_CALL]: GoToPhone,
        [ACTION.GO_TO_WHATSAPP]: GoToWhatsapp,
        [ACTION.LOGOUT]: onLogoutPress,
        [ACTION.OPEN_MENU]: openMenu,
        [ACTION.HANDLE_CONNECTION]: handleConnection,
    },
    action: {
        routeId: ROUTE.PARTNER_REFERRED_PARTNER,
        type: ACTION.ON_LOAD,
        payload: {},
    },
};
